<template>
  <button
    :class="`ryoma--${type}`"
    @click.prevent="startFunnel"
    v-html="text">{{text}}</button>
</template>

<script>
export default {
  name: 'ryoma-cta',
  props: ['type', 'text', 'service'],
  methods: {
    startFunnel: function () {
      this.$router.push({ name: 'step-1', params: { service:  this.service} })
    }
  }
}
</script>